// extracted by mini-css-extract-plugin
export default {"bonuses":"BonusCardsGrid__bonuses--lc-Xh_q2","component":"BonusCardsGrid__component--lc-yy40K","list":"BonusCardsGrid__list--lc-zpRut","item":"BonusCardsGrid__item--lc-ws_oW"};